import React from "react";
import "./About.scss";

const About: React.FC = () => {
  return (
    <div className="about-container">
      <div className="hero-section">
        <div className="image-container">
          <h1>What We Do</h1>
          <p>Find a simple way for seamless apparel production!</p>
        </div>
      </div>
      <div className="content-section">
        <h2>PROFILE of YAMUNA FASHION</h2>
        <hr />
        <blockquote>
          A formal factory that is cooperating with popular brands to make your seamless clothing
          production SIMPLE, EFFICIENT, and REASONABLE.
        </blockquote>
        <p>
          Founded in 2020, YAMUNA FASHION specializes in high-quality seamless clothing and activewear
          production. Based in India, the company offers a modern facility with cutting-edge technology
          and a dedicated workforce to deliver premium products to customers worldwide.
        </p>
        <p>
          With over 10,000 square meters of manufacturing space and 100+ skilled employees, we maintain
          daily production of 15,000 seamless items. Using advanced seamless circular knitting machines,
          we deliver precision and quality in every piece.
        </p>
        <p>
          As a trusted brand, YAMUNA FASHION strives to fulfill all customization requirements with a
          focus on excellence and innovation.
        </p>
        <h3>Production Range:</h3>
        <ol>
          <li>
            <strong>Seamless Clothing</strong>
            <br />
            <br></br>
            Including seamless leggings, seamless T-shirts, seamless bras, seamless underwear, seamless
            panties, seamless shapewear, seamless tops, and all kinds of seamless knitting items.
          </li>
          <li>
            <strong>Fitness Apparel, Gym Clothing, Sportswear</strong>
            <br />
            <br></br>
            Including workout leggings, yoga pants, sports bras, crop tops, zipped tops, tracksuits,
            sweaters, headbands, and hoodies.
          </li>
          <li>
            <strong>Compression Clothing</strong>
            <br />
            <br></br>
            Including compression leggings, shorts, waistbands, and tops.
          </li>
        </ol>
        <p>Wish to be your friend and partner!</p>
      </div>
    </div>
  );
};

export default About;
